import {Location} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {Params} from '@angular/router';
import {
  CartProductReplace,
  CartRemoteService,
  ListTable,
  NgxEasyTablePagination,
  PageApiResponse,
  ProductCustomer,
  StoreService
} from 'compob2b-libs';
import {catchError, map, switchMap, take, takeUntil, tap} from 'rxjs/operators';
import {UtilsService} from '../../utils/utils.service';

@Component({
    selector: 'app-product-analogs',
    templateUrl: './product-analogs.component.html',
    standalone: false
})
export class ProductAnalogsComponent extends ListTable implements OnInit {
  pagination: NgxEasyTablePagination;
  productList: ProductCustomer[];

  constructor(
    readonly storeService: StoreService,
    readonly location: Location,
    readonly cartService: CartRemoteService,
  ) {
    super();
  }

  ngOnInit(): void {
    const productUid = this.route.snapshot.paramMap.get('uid');

    this.route.queryParams.pipe(
      switchMap(params => this.getProductAnalogs(productUid, params)),
    ).subscribe();
  }

  private getProductAnalogs(productUid: string, params: Params) {
    this.loading = true;
    const uri = '/product/' + productUid + '/analogs';

    const queryParams = UtilsService.buildQueryParams(params);

    return this.compoApiService.getWithParams<PageApiResponse<ProductCustomer[]>>(uri, queryParams)
      .pipe(
        take(1),
        catchError(err => this.handleError(err)),
        tap(_ => this.updatePagination(params)),
        tap(response => this.handleResponse(response.data)),
        map(response => {
          this.productList = response.data.content;
        })
      );
  }

  select(analog: ProductCustomer) {
    const cartProductReplace: CartProductReplace = {
      productId: this.productList[0].id,
      analogId: analog.id
    };
    this.storeService.nextReplaceAnalog(cartProductReplace);
    this.location.back();
  }

  replace(analog: ProductCustomer) {
    const cartProductReplace: CartProductReplace = {
      productId: this.productList[0].id,
      analogId: analog.id
    };

    this.loading = true;
    this.cartService.replace(cartProductReplace).pipe(
      takeUntil(this.unsubscribe),
    ).subscribe(_ => {
      this.loading = false;
      this.router.navigate(['/cart']).then(_ => this.cartService.replaceCartProduct());
    });
  }

  back() {
    this.storeService.nextReplaceAnalog(null);
    this.location.back();
  }

}
